import { MEGABYTE_IN_BYTES } from "./constants";

export const getMBFromBytes = bytes => {
    return (bytes / MEGABYTE_IN_BYTES).toFixed(3);
}
export const fileToBase64 = file => {
    const reader = new FileReader();
    return new Promise((res, rej) => {
        reader.readAsDataURL(file); // Definiendo archivo a leer
        reader.onload = () => {            
            res(reader.result.split(",")[1]);
        };
        reader.onerror = (err) => {
            reader.abort();
            rej(err);
        };
    });
}
export const getfileTypes = (fileTypes) => {
    return fileTypes.map(type => `.${type}`).join(", ");
}
export const isValidMBSize = (sizeMB, maxSizeMB) => {
    return sizeMB > 0.00000 && sizeMB <= maxSizeMB;
}
export const isEmptyFile = byteSize => {
    return byteSize === 0;
}
export const isValidByteSize = (byteSize, maxByteSize) => {
    return byteSize <= maxByteSize;
}
export const isValidFileType = (fileTypes, fileName) => {
    const fileType = getFileTypeByFileName(fileName);
    return fileTypes.includes(fileType);
}
const getFileTypeByFileName = (fileName) => {
    if (!fileName.includes("."))
        return false;
    return fileName.split(".").pop();
}